import React from "react";
import { Tag } from "antd";
import { CloseOutlined, FilterFilled } from "@ant-design/icons";

// The "Filtered from ..." chip shown on a landing grid that was opened from
// another page (the Analytics workspace, the Executive Dashboard). Extracted
// from the Invoice Dashboard because four pages now need it.
//
//   label       what the filter came from, e.g. "Filtered from Dashboard"
//   items       display strings for each imported filter, joined with " · "
//   onClear     removes ONLY the imported filters; the page's own local filters
//               are untouched
//   clearLabel  accessible name of the close control
const FilteredViewChip = ({
  label = "Filtered from Analytics",
  items = [],
  onClear,
  clearLabel = "Clear imported filter",
}) => {
  const shown = items.filter(Boolean);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        margin: "8px 0 0 0",
        flexWrap: "wrap",
      }}
    >
      <Tag
        icon={<FilterFilled />}
        closable={Boolean(onClear)}
        closeIcon={<CloseOutlined aria-label={clearLabel} />}
        onClose={(event) => {
          event.preventDefault();
          onClear?.();
        }}
        color="blue"
      >
        {shown.length ? `${label}: ${shown.join(" · ")}` : label}
      </Tag>
    </div>
  );
};

export default FilteredViewChip;
